module.exports = __webpack_public_path__ + "static/media/userproperty.0407071c.svg";